import { TapRequestFrame } from '@iotize/tap/client/api';

export class TapRequestFrameBuilder {
  public static MAX_ID = 0xffff;

  // public static fromBytes(bytes: Uint8Array): Header {
  //     const path = TapStreamReader.fromArray(bytes).readTapRequestPath();
  //     const header = new Header(path);
  //     if (bytes.length == 8) {
  //         // What is that ???
  //         header.resourceInstance =
  //             ((bytes[6] << 8) & Header.MAX_ID) + (bytes[7] & 0xff);
  //         header.resourceInstance &= Header.MAX_ID;
  //     }
  //     // return header;
  //     return header;
  // }

  public static parsePath(path: string): TapRequestFrame.Path {
    if (!path || path.length === 0) {
      throw new Error('Missing LWM2M path, it must not be empty'); // TODO better error
    }
    path = path.trim();
    const result = path.match(TapRequestFrameBuilder.PATH_EXPRESSION);
    if (!result || result.length === 0) {
      throw new Error(
        `Invalid LWM2M path "${path}", it does not match expected format`,
      ); // TODO better error
    }
    const header: TapRequestFrame.Path = {
      objectId: this.validateId(parseInt(result[1])),
      objectInstanceId: result[2] ? parseInt(result[2]) : 0xffff,
      resourceId: parseInt(result[3]),
    };
    if (result[4]) {
      (header as any)['resourceInstanceId'] = parseInt(result[4], 10);
    }
    return header;
  }

  public static GET(url: string, body?: Uint8Array): TapRequestFrame {
    return TapRequestFrameBuilder.create(
      TapRequestFrame.MethodType.GET,
      url,
      body,
    );
  }

  public static PUT(url: string, body?: Uint8Array): TapRequestFrame {
    return TapRequestFrameBuilder.create(
      TapRequestFrame.MethodType.PUT,
      url,
      body,
    );
  }

  public static POST(url: string, body?: Uint8Array): TapRequestFrame {
    return TapRequestFrameBuilder.create(
      TapRequestFrame.MethodType.POST,
      url,
      body,
    );
  }

  public static create(
    method: TapRequestFrame.MethodType,
    url: string,
    data?: Uint8Array,
  ): TapRequestFrame {
    return {
      header: {
        path: TapRequestFrameBuilder.parsePath(url),
        methodType: method,
      },
      payload: data || new Uint8Array(),
    };
  }

  static validateId(id: number): number {
    if (id < 0 || id > TapRequestFrameBuilder.MAX_ID) {
      throw new Error(
        `Invalid identifier "${id}". It must be a number between ${id} and ${TapRequestFrameBuilder.MAX_ID}`,
      );
    }
    return id;
  }
}

export namespace TapRequestFrameBuilder {
  export const PATH_EXPRESSION =
    /^\/?([0-9]+)\/([0-9]+)?\/([0-9]+)\/?([0-9]+)?$/;
}
